export default 'application/epub+zip';